import React from "react";
import { styled } from "@mui/system";
import { COLORS } from "../../ui/Theme";

const StyledTextArea = styled("textarea")(({ theme }) => ({
  width: "100%",
  height: "46px",
  fontSize: "14px",
  padding: "8px 12px",
  border: "none",
  borderRadius: "12px",
  backgroundColor: theme.palette.mode === "light" ? COLORS.INPUTBG : "#303030",
  fontFamily: theme.typography.fontFamily,
  resize: "none",
  outline: "none",
}));

const TextArea = React.forwardRef(({ ...props }, ref) => {
  return <StyledTextArea ref={ref} {...props} />;
});

export default TextArea;
